<template>
  <div class="container step">
    <div class="head-top">
      <img src="../../assets/step1/page1_head.png" alt="">
      <div class="text">
        針對第一線不適合Cisplatin療法的病患,在接受TECENTRIQ治療後，整體存活期中位數
        <span class="caption">mOS</span> 達 <span class="caption">16.3</span>個月<br/>
        <h5 style="color:#6c4883;margin:0;">(IMvigor 210 Phase II, n=119)</h5>
      </div>
    </div><!-- Top end sub-->
    <div class="flow-container">
      <a href="#" @click.prevent="selectFlow.flow1 = !selectFlow.flow1">
        <span class="flow-text">IMvigor 210 Phase II, multicenter, open-label,
          2-cohort trial design in locally advanced or metastatic urothelial carcinoma (n=119)</span>
        <img v-if="selectFlow.flow1 === false" src="../../assets/step1/page1_left.png" alt="">
        <img v-if="selectFlow.flow1" src="../../assets/step1/page1_left_change.png" alt="">
      </a>
      <a href="#" @click.prevent="selectFlow.flow2 = !selectFlow.flow2">
        <span class="flow-text">
            EORTC Study 30986 Randomized Phase II/III Trial Assessing GC and M-CAVI in Patients With Advanced UC Who Are Unfit for Cisplatin-Based Chemotherapy（n=238）
        </span>
        <img v-if="selectFlow.flow2 === false" src="../../assets/step1/page1_right.png" alt="">
        <img v-if="selectFlow.flow2" src="../../assets/step1/page1_right_change.png" alt="">
      </a>
    </div>
    <template>
      <router-link to="/step1-1" class="btn-prev el-icon-arrow-left"></router-link>
      <router-link to="/step2" class="btn-next el-icon-arrow-right"></router-link>
    </template>
    <div class="footerText">
        <ol>
          <li>
            2018 American Society of Clinical Oncology (Asco) June 1-5,2018, Chicago, IL, USA Abstract#4523
          </li>
          <li>
            Bellmunt et al. J Clin Oncol 2012; 5. De Santis et al. J Clin Oncol 2012
          </li>
        </ol>
    </div>
  </div>
</template>

<script>
export default {
  name: 'step1-2',
  props: ['result'],
  mounted: function () {
    console.log(this.result)
  },
  data () {
    return {
      pageChage: false,
      selectFlow: {
        flow1: false,
        flow2: false
      }
    }
  }
}
</script>

<style scoped>
  a[class*="btn-"] {
    background:#aa89bd;color:white;
  }
  a {text-decoration:none;}
  .flow-text {
    color:#5f5f5f;font-size:14px;text-align:left;display:block;
    margin-bottom:20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/step1/flow.vue